
define(
	'C3.ShoppingExtensions.PLP'
,   [
		'C3.ShoppingExtensions.VisualSystemPage.View',
		'Profile.Model'
	]
,   function (
		VisualSystemPageView,
		ProfileModel
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
	
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			var PLP = container.getComponent('PLP');
			var environment = container.getComponent("Environment");
			var Configuration = environment.application.Configuration;

			var profile = ProfileModel.getInstance()
			//,   is_loading = !Configuration.get('performance.waitForUserProfile', true) && ProfileModel.getPromise().state() !== 'resolved'
            ,   is_logged_in = (profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F')
           	
			
			if(layout && PLP)
			{
				layout.addChildView('VisualSystemTemplate.View', function () 
		        {
		        	var plp = container.getComponent('PLP');
					var categoryinfo = plp.getCategoryInfo();
					if(categoryinfo)
					{
						
						var system8_data = Configuration.System8Page
			 			,   system8_config_data = system8_data.config;

						 var findMatchingSystem8 = _.findWhere(system8_config_data, {
		                    urlfragment: categoryinfo.urlfragment
		                });

						//console.log(findMatchingSystem8)

						return new VisualSystemPageView(
		                {
		                	application: environment.application,
		                	category : categoryinfo,
		                	configuration : Configuration,
		                	container : container,
		                	layout : layout
		                });
						
					}

		        });
			}

		}
	};
});
